import { JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { Adresse } from './adresse';
import { Portefeuille } from './portefeuille';
import { Region } from './region';

@JsonObject
export class BrsTiers {
  constructor (
    numTiers?: string,
    typeTiers?: string,
    raisonSociale?: string,
    adresses?: Adresse[]
  ) {
    this.numTiers = numTiers as any;
    this.typeTiers = typeTiers as any;
    this.raisonSociale = raisonSociale as any;
    this.adresses = adresses as any;
  }

  @JsonProperty(String)
  numTiers?: string;

  @JsonProperty(String)
  typeTiers?: string;

  @JsonProperty(String)
  raisonSociale?: string;

  @JsonProperty([Adresse])
  @Optional
  adresses: Adresse[]

  @JsonProperty(Portefeuille)
  @Optional
  conseillerPv?: Portefeuille

  @JsonProperty(Region)
  @Optional
  region: Region
}
